module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Job"
  }, [_c('div', {
    staticClass: "FirstTitle"
  }, [_vm._m(1), _vm._v(" "), _c('img', {
    staticClass: "backPic",
    attrs: {
      "src": _vm.button1
    },
    on: {
      "mouseover": _vm.mouseOn,
      "mouseout": _vm.mouseOut,
      "click": _vm.onclick
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "handle",
    attrs: {
      "src": _vm.Buttonn
    },
    on: {
      "mouseover": _vm.mouseOnn,
      "mouseout": _vm.mouseOutt,
      "click": _vm.onclickk
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Joinbanner"
  }, [_c('img', {
    staticClass: "JobsBanner",
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/Innerbanner.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("JAVA高级开发工程师"), _c('img', {
    staticClass: "hotPic",
    attrs: {
      "src": require("../assets/ho-t.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('h4', [_vm._v("职位描述")]), _vm._v(" "), _c('p', [_vm._v("1、独立完成中小型项目的系统分析、设计，并主导完成详细设计和编码的任务，确保项目的进度和质量;"), _c('br'), _vm._v(" 2、参与建设通用、灵活的业务基础平台，支撑上层多场景的业务;\n\n          "), _c('br'), _vm._v(" 3、执行代码检查并提供优化建议，对部分人员进行JAVA技术、开发技能等知识普及及能力培养;\n\n          "), _c('br'), _vm._v(" 4、改善、维护和优化相关的产品的质量、性能、提升用户使用体验。\n\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('h4', [_vm._v("任职要求：")]), _vm._v(" "), _c('p', [_vm._v("1、5年以上应用系统设计及开发经验；"), _c('br'), _vm._v(" 2、精通负载均衡机制、应用集群搭建、数据库集群搭建；\n\n          "), _c('br'), _vm._v(" 3、精通J2EE技术平台及主流框架，具有Hibernate、Spring、Struts、mybatis等框架开发经验，深刻理解SpringMVC；\n\n          "), _c('br'), _vm._v(" 4、精通Web页面开发，熟练运用HTML、JavaScript、ajax、css、JQuery;\n\n          "), _c('br'), _vm._v(" 5、精通Tomcat等主流J2EE应用服务,能在Unix/Linux上布署服务;\n\n          "), _c('br'), _vm._v(" 6、精通MySQL等数据库，熟悉关系数据库应用设计开发及优化;\n\n          "), _c('br'), _vm._v(" 7、有基于阿里云平台的研发经验优先考虑；\n\n          "), _c('br'), _vm._v(" 8、有大数据或高并发数据库开发经验优先考虑。\n\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('h4', [_vm._v("薪酬福利：")]), _vm._v(" "), _c('p', [_vm._v("1、各类假期：带薪年假、带薪病假、婚假、产假、国家法定假期，一样都不能少；"), _c('br'), _vm._v(" 2、完善的福利：五险一金、股权激励、免费班车；\n\n          "), _c('br'), _vm._v(" 3、薪酬待遇：有竞争力的薪酬福利待遇体系，丰厚的年终奖金等着你来拿；\n\n          "), _c('br'), _vm._v(" 4、公司活动：不定期举办各类员工活动，月度生日会、节日活动、图书分享会，每周花样文体活动等着你来参加；\n\n          "), _c('br'), _vm._v(" 5、工作环境：公司提供优美的办公环境，提供优质资源；\n\n          "), _c('br'), _vm._v(" 6、吃货福利：蛋糕、甜点、水果、饮料等其他小零食。\n\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('h4', [_vm._v("工作地址：")]), _vm._v(" "), _c('p', [_vm._v("广州 - 天河区 - 体育东路122号羊城国际商贸中心东塔3209单元   "), _c('span', {
    staticStyle: {
      "color": "#0099cc",
      "font-family": "FZLTXHK-GBK1-0",
      "font-size": "16px",
      "line-height": "1.88",
      "letter-spacing": "0.8px"
    }
  }, [_vm._v("查看地图 >")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c73f383","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobsDetails.vue
// module id = 275
// module chunks = 1